// Central, replaceable INDRIL brand mark. Swap the two files in /public
// (indril-mark.png = square logo mark, indril-wordmark.png = full wordmark)
// with the final artwork and the whole site updates without layout changes.
export const LOGO_MARK = "/indril-mark.png";
export const LOGO_WORDMARK = "/indril-wordmark.png";

export const Logo = ({ variant = "lockup", className = "", markClass = "", showWordText = true }) => {
  if (variant === "mark") {
    return <img src={LOGO_MARK} alt="INDRIL" className={`object-contain ${className}`} data-testid="brand-logo-mark" />;
  }
  if (variant === "wordmark") {
    return <img src={LOGO_WORDMARK} alt="INDRIL — India's Own Social Media Platform" className={`object-contain ${className}`} data-testid="brand-logo-wordmark" />;
  }
  // lockup: mark + brand text
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img src={LOGO_MARK} alt="INDRIL" className={`object-contain ${markClass || "h-9 w-9"}`} />
      {showWordText && (
        <span className="font-display text-xl font-semibold tracking-tight text-white">
          IND<span className="text-indril-saffron">RIL</span>
        </span>
      )}
    </span>
  );
};
